// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"c04b35aa","24":"d7c78a19","131":"d05f5a9d","172":"bbad152d","248":"c530b17a","512":"c7663bfb","541":"2e07d3b0","637":"48ac9ab2","661":"be3acd04","679":"18293b87","718":"50da3296","819":"508e4f34","845":"7cf4d17c"}[chunkId] + ".chunk.js";
};